import * as Sentry from '@sentry/react';

import { isProduction } from 'config'

Sentry.init({
  dsn: 'https://388c2540878af6689e623528ba0e2585@o4508731826110464.ingest.de.sentry.io/4510584028987472',
  debug: !process.env.REACT_APP_BUILD_TYPE,
  environment: process.env.REACT_APP_BUILD_TYPE + ' Joy',
  // replaysOnErrorSampleRate: 1,
  integrations: [
    Sentry.httpClientIntegration(),
    // Sentry.replayIntegration({
    //   //do not capture text or inputs for production
    //   maskAllText: isProduction,
    //   maskAllInputs: isProduction,
    // }),
  ],
});
